<div class="storage-alert">
  <span>
    {{ 'STORAGE_ALERT' | translate }}
  </span>
  <button mat-button [routerLink]="TASKS_URL">
    <mat-icon>synchronize</mat-icon>
    {{ 'STORAGE' | translate }}
  </button>
</div>
